import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'servicedesk-knowledge-common.create-article-button.modal.heading',
		defaultMessage: 'Create article',
		description: 'The modal heading displayed to the user when create article modal is opened',
	},
	selectLabel: {
		id: 'servicedesk-knowledge-common.create-article-button.modal.select-label',
		defaultMessage: 'Select a knowledge base space',
		description: 'The message shown to the user describing the dropdown contents',
	},
	selectPlaceholder: {
		id: 'servicedesk-knowledge-common.create-article-button.modal.select-placeholder',
		defaultMessage: 'Enter a space name',
		description: 'Asking the user to choose a space from the dropdown contents.',
	},
	cancelBtnText: {
		id: 'servicedesk-knowledge-common.create-article-button.modal.cancel-btn-text',
		defaultMessage: 'Cancel',
		description: 'The button text which tells the user to cancel the create article action',
	},
	nextBtnText: {
		id: 'servicedesk-knowledge-common.create-article-button.modal.next-btn-text',
		defaultMessage: 'Next',
		description:
			'The button text which tells the user to move to next action while creating an article',
	},
});
